// create single session table component

const { useNavigate } = require("react-router-dom");
import { Card, Icon, Pagination } from "@mui/material";
import SessionsApi from "Classes/API/Administration/SessionsApi";
import CreateAccountingSession from "Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import Loader from "Loader";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { LanguageContext } from "App";
import AddmissionButton from "layouts/AccountingSessions/AddmissionButton";
import { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";

const PatientSingleSessionsTable = ({ CurrentUser, patient }) => {
  const { translations } = useContext(LanguageContext);
  let navigate = useNavigate();

  const TableColumns = [
    {
      Header:
        translations.userManagementInfoUserAccountingSessionsforAccSessionID,
      accessor: "Id",
      align: "left",
    },

    {
      Header: translations.userManagementInfoUserAccountingSessionsforSession,
      accessor: "Session",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingSessionsforPatient,
      accessor: "Patient",
      align: "left",
    },

    {
      Header: translations.userManagementInfoUserAccountingSessionsforTherapist,
      accessor: "Therapist",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingSessionsforPaidFor,
      accessor: "PaidFor",
      align: "left",
    },
    {
      Header:
        translations.userManagementInfoUserAccountingSessionsforAddmission,
      accessor: "Addmission",
      align: "left",
    },

    {
      Header:
        translations.userManagementInfoUserAccountingSessionsforOriginalPrice,
      accessor: "OriginalPrice",
      align: "left",
    },
    {
      Header: translations.userManagementInfoUserAccountingSessionsforDiscount,
      accessor: "Discount",
      align: "left",
    },
    {
      Header:
        translations.userManagementInfoUserAccountingSessionsforFinalPrice,
      accessor: "FinalPrice",
      align: "left",
    },

    {
      Header: translations.userManagementInfoUserAccountingSessionsforDetails,
      accessor: "Edit",
      align: "center",
    },
    // { Header: "Delete", accessor: "Delete", align: "center" },
  ];

  const [TotalAccountingItems, setTotalAccountingItems] = useState(0);
  const [SearchReq, setSearchReq] = useState(new CreateAccountingSession());
  const [TableDataRows, setTableDataRows] = useState([]);

  const [ResponseData, setResponseData] = useState({});
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);

  const [IsLoaded, setIsLoaded] = useState(false);

  const GetTherapistSessions = async () => {
    let req = new SearchStringOrIntReq3();

    req.SearchInt = CurrentUser.getTherapist.id;

    console.log(req);

    var res = await SessionsApi.GetTherapistAccountingSessions(req);

    console.log(res);
    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];
      setResponseData(tempResponseData);
      setIsLoaded(true);
    }
  };

  const DeleteSession = async (id) => {
    if ((!["Admin", "Owner", "HeadAccounting"].includes(CurrentUser.userType))) {
      Swal.fire({
        title: "Sorry, you do not have this permission.",
        text: "Visit your admin to request this permission.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.value) {
        let delReq = new SearchStringOrIntReq3();
        delReq.SearchInt = id;
        var res = await SessionsApi.DeleteAccountingSession(delReq);

        if (res.status == "Success") {
          Swal.fire("Deleted!", "Session has been deleted.", "success");
          setIsLoaded(false);
        } else {
          Swal.fire("Failed!", "Session deletion failed.", "error");
        }
      }
    });
  };

  const GetOptions = (session) => {
    if (
      (!["Admin", "Owner", "HeadAccounting"].includes(CurrentUser.userType)) &&
      CurrentUser.userType != "Therapist" &&
      CurrentUser.userType != "AccountingEmployee" &&
      CurrentUser.userType != "AppointmentEmployee" &&
      CurrentUser.userType != "CallCenterEmployee"
    ) {
      Swal.fire({
        title: "Access Denied",
        text: "Visit your admin to request this permission.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (CurrentUser.userType === "Therapist") {
      navigate("/Users/Options/AccSessionDetails", {
        state: {
          SearchSession: session,
        },
      });
    } else {
      navigate("/Users/Options/AccSessionDetails", {
        state: {
          SearchSession: session,
        },
      });
    }
  };

  const MakeTableRow = (session, index) => {
    console.log("MakeTableRow", session);

    return {
      Id: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {session.id}
        </MDTypography>
      ),

      Session: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {session.sessionName}
        </MDTypography>
      ),

      Patient: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {session.patientName}
        </MDTypography>
      ),
      Therapist: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {session.therapistName}
        </MDTypography>
      ),
      PaidFor: (
        <input
          id={"S.isPaidFor" + session.id}
          type="checkbox"
          disabled
          checked={session.isPaidFor ? "on" : ""}
        />
      ),
      Addmission: <AddmissionButton AccSession={session} />,
      OriginalPrice: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {session.originalPrice}
        </MDTypography>
      ),

      Discount: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {Number(session.discount).toFixed(1)}%
        </MDTypography>
      ),

      FinalPrice: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {session.finalPrice}
        </MDTypography>
      ),

      Edit: (
        <MDTypography
          onClick={() => {
            GetOptions(session);
          }}
          component="a"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          <Icon>more_vert</Icon>
        </MDTypography>
      ),
      // Delete: (
      //   <MDButton onClick={() => DeleteSession(session.id)} variant="gradient" color="dark">
      //     <Icon sx={{ fontWeight: "bold" }}>delete</Icon>

      //   </MDButton>
      // ),
    };
  };

  const GetTableData = async () => {
    SearchReq.pagingParams.pageSize = 5;
    SearchReq.pagingParams.pageNumber = Page;
    SearchReq.patientId = patient.getPatient?.id;
    console.log(SearchReq);
    var res = await SessionsApi.SearchAccountingSessions(SearchReq);
    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];
      setResponseData(tempResponseData);
      setTotalAccountingItems(res.data.totalItems);
      setPaginationPages(res.data.totalPages);
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    GetTableData();
  }, [Page]);

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };

  useEffect(async () => {}, [TotalAccountingItems]);

  useEffect(() => {
    //Get data

    if (ResponseData.length > 0) {
      RefreshTable(ResponseData);
    } else {
      setTableDataRows([]);
    }
  }, [ResponseData]);

  if (!IsLoaded) {
    const loaderType = "balls";
    const loaderColor = "black";

    return <Loader type={loaderType} color={loaderColor} />;
  }
  return (
    <>
      <Card sx={{ marginTop: "15px" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={3}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <div class="text-center">
            <MDTypography variant="h4" color="white">
              {translations.userManagementInfoUserAccountingSessionsfor}{" "}
              {patient.name}
            </MDTypography>
            <MDTypography className="h6" color="white">
              <strong>
                {translations.userManagementInfoUserAccountingSessionsfor}:{" "}
                {TotalAccountingItems}
              </strong>
            </MDTypography>
          </div>
          {CurrentUser && CurrentUser.userType == "Therapist" && (
            <MDButton
              onClick={() => {
                GetTherapistSessions();
              }}
              variant="gradient"
              color="light"
            >
              <Icon sx={{ fontWeight: "bold" }}>search</Icon>
              <MDTypography
                component="span"
                variant="button"
                color="text"
                fontWeight="medium"
              >
                Find My Sessions
              </MDTypography>
            </MDButton>
          )}
        </MDBox>
        <MDBox p={3}>
          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
          <div className="text-right mx-3 my-4">
            <Pagination
              count={PaginationPages}
              color="primary"
              onChange={(e, num) => setPage(num)}
              className="float-right"
            />
          </div>
        </MDBox>
      </Card>
    </>
  );
};

export default PatientSingleSessionsTable;
